
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {ref, set} from 'firebase/database';
import {db} from '@/firebase';
import {PadoRoll} from '@/types/PadoRoll';
import PadoStatsComponent from '@/components/ParceDomine/PadoStatsComponent.vue';
import PadoCharSheetComponent from '@/components/ParceDomine/PadoCharSheetComponent.vue';
import {DamageRoll} from '@/types/DamageRoll';
import PadoMapComponent from '@/components/ParceDomine/PadoMapComponent.vue';
import PadoPlayerTurnOrderComponent from '@/components/ParceDomine/PadoPlayerTurnOrderComponent.vue';
import PadoPlayerInventoryComponent from '@/components/ParceDomine/PadoPlayerInventoryComponent.vue';
import {RollMixin} from '@/mixins/RollMixin';

@Component({
    components: {
        PadoPlayerInventoryComponent,
        PadoPlayerTurnOrderComponent, PadoMapComponent, PadoCharSheetComponent, PadoStatsComponent},
})
export default class PadoPlayerComponent extends mixins(RollMixin) {
    critic = false;
    modalHealth = false;
    modalRi = false;
    modalHealthText = '';
    modalRiText = '';

    async roll(stat: string): Promise<void> {
        if (this.game && this.game.characters[this.$store.state.user.uid]) {
            const roll: PadoRoll = new PadoRoll(stat, this.game.characters[this.$store.state.user.uid].name);
            await roll.roll(this.game.characters[this.$store.state.user.uid], this.secret);
            await this.addRoll(roll);
            await this.addGlobalRoll(roll);
        }
    }

    async rollDamage(type: string): Promise<void> {
        if (this.game) {
            const roll: DamageRoll = new DamageRoll(type, this.game.characters[this.$store.state.user.uid].name);
            roll.roll(null, this.secret);
            await this.addRoll(roll);
            await this.addGlobalRoll(roll);
        }
    }

    async useAbility(ri: number, name: string): Promise<void> {
        this.game.characters[this.$store.state.user.uid].stats.filter(stat => stat.name === 'ri')[0].current -= ri;
        await (set(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}`), this.game.characters[this.$store.state.user.uid]));
        const abilityRoll = new PadoRoll(name, this.game.characters[this.$store.state.user.uid].name);
        abilityRoll.critic = false;
        abilityRoll.passed = true;
        abilityRoll.rolled = 0;
        abilityRoll.text = name;
        abilityRoll.setCSSClass();
        await this.addGlobalRoll(abilityRoll);
        await this.addRoll(abilityRoll);
    }
}
